import {get, post} from "../../util/request";
import {
  TerminalPrmInfoRequest
} from "../terminalPrm";

export interface ITerminalPRMRInfoEInvoiceCfg {
  id: string;
  terminalId: string;
  einvoice: EInvoice.IEInvoice;
}
export interface ITerminalPRMRInfoEInvoiceData {
  id: string;
  terminalId: string;
  data: string;
}

export interface ITerminalPRMRInfoDataResponse {
  url: string;
}

export const terminalPrmInfoEInvoiceCfg = (params: TerminalPrmInfoRequest) => {
  return get<ITerminalPRMRInfoEInvoiceCfg>({url: "/api/terminal-prm/info/einvoice/cfg", params})
}

export const saveTerminalPrmInfoEInvoiceCfg = (data: ITerminalPRMRInfoEInvoiceCfg) => {
  return post({url: "/api/terminal-prm/info/einvoice/cfg", data})
}

export const terminalPrmInfoEInvoiceData = (params: TerminalPrmInfoRequest) => {
  return get<ITerminalPRMRInfoEInvoiceData>({url: "/api/terminal-prm/info/einvoice/data", params})
}

export const saveTerminalPrmInfoEInvoiceData = (data: ITerminalPRMRInfoEInvoiceData) => {
  return post<ITerminalPRMRInfoDataResponse>({url: "/api/terminal-prm/info/einvoice/data", data})
}
